/**
 * sessionActions.js
 *
 * ⭐ ONE ACTION THAT EMPTIES THE WHOLE STORE, because per-slice cleanup does not scale.
 *
 * ⛔ THE LEAK THIS CLOSES (2026-08-31, found by the operator). Logged in as the Book Creator, he
 * searched the Voice Opportunities Marketplace for LitGroup "LN Canary LG A" filtered to Narrator.
 * He then logged out, logged in as a Voice Actor, opened the same page — and was shown the Book
 * Creator's search profile AND result set. A different user, a different role, another user's data
 * on screen.
 *
 * WHY IT SURVIVED. Redux state is cleared by a full page load, and `Logout` navigates with the
 * router — no reload. So everything in the store carries straight into the next session. Only ONE
 * slice was ever cleared (`resetDirectAssets`, written for exactly this symptom in the Rendering
 * Studio's LitGroup picker). Measured across the 22+ slices in the store, that was the only one:
 * applications, messages, opportunities, cast, prototypes and book-creator state all persisted.
 *
 * ⚠️ SO A SECOND PER-SLICE RESET WOULD HAVE BEEN THE WRONG FIX. It would have closed this one
 * report and left the next slice — and the one after that — with the same hole, discoverable only
 * by someone noticing another user's data on their screen. Resetting at the ROOT means a slice
 * added tomorrow is covered without anyone remembering to cover it.
 *
 * ⓘ This is client-side hygiene, not an authorisation boundary. The server re-authorises every
 * request, so a stale row could be SEEN but never usefully acted on. Seeing it is the problem.
 */

/** Dispatched when one user's session ends and the store must not outlive it. */
export const SESSION_ENDED = 'session/ended';

export const sessionEnded = () => ({ type: SESSION_ENDED });
